<template>
  <div class="update-mgt-page">
    <div class="global-header-wrap">
      <span v-if="!$route.query.id">{{ $t('commonMsg.new') }}</span>
      <span v-else>{{ $t('commonMsg.edit') }}</span>
      <div>
        <button class="global-button-style" @click="$router.back()">
          {{ $t('commonMsg.back') }}
        </button>
        <button class="global-button-style" @click="submitForm('ruleForm')">
          {{ $t('commonMsg.save') }}
        </button>
      </div>
    </div>
    <el-card
      class="app-table-container"
      :body-style="{ padding: '20px' }"
      v-bar
    >
      <div class="body-wrap params-wrap">
        <el-form
          label-width="120px"
          :model="form"
          @submit.native.prevent
          ref="ruleForm"
          label-position="top"
          :rules="rules"
        >
          <el-form-item label="标题" prop="title">
            <el-input v-model="form.title" class="fl" clearable></el-input>
          </el-form-item>
          <el-form-item label="是否启用">
            <el-radio-group v-model="form.usable">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="识别同个IP">
            <el-radio-group v-model="form.ip">
              <el-radio label="yes">是</el-radio>
              <el-radio label="no">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="识别同个MAC">
            <el-radio-group v-model="form.mac">
              <el-radio label="yes">是</el-radio>
              <el-radio label="no">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="方法" prop="method">
            <el-select v-model="form.method" placeholder="请选择" clearable>
              <el-option
                v-for="item in ['GET', 'POST', 'PUT', 'DELETE']"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="API" prop="path">
            <el-input v-model="form.path" class="fl" clearable></el-input>
          </el-form-item>
          <el-form-item label="描述" prop="desc">
            <el-input v-model="form.desc" class="fl" clearable></el-input>
          </el-form-item>
          <el-row :gutter="20">
            <el-col :span="8" :offset="0">
              <el-form-item label="秒级单位" prop="seconds">
                <el-input
                  type="number"
                  v-model="form.seconds"
                  class="fl"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="0">
              <el-form-item
                label="秒级数量预警/0不限制"
                prop="secondsWarningCount"
              >
                <el-input
                  type="number"
                  v-model="form.secondsWarningCount"
                  class="fl"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="0">
              <el-form-item
                label="秒级数量限制/0不限制"
                prop="secondsLimitCount"
              >
                <el-input
                  type="number"
                  v-model="form.secondsLimitCount"
                  class="fl"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="0">
              <el-form-item label="每日数量预警/0不限制" prop="dayWarningCount">
                <el-input
                  type="number"
                  v-model="form.dayWarningCount"
                  class="fl"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="0">
              <el-form-item label="每日数量限制/0不限制" prop="dayLimitCount">
                <el-input
                  type="number"
                  v-model="form.dayLimitCount"
                  class="fl"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="0">
              <el-form-item
                label="每月数量预警/0不限制"
                prop="monthWarningCount"
              >
                <el-input
                  type="number"
                  v-model="form.monthWarningCount"
                  class="fl"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="0">
              <el-form-item label="每月数量限制/0不限制" prop="monthLimitCount">
                <el-input
                  type="number"
                  v-model="form.monthLimitCount"
                  class="fl"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="请求对象query">
            <div
              class="parms-list"
              v-for="(item, index) in queryParams"
              :key="index"
            >
              <el-input v-model="item.key" clearable placeholder="字段" />
              <el-input v-model="item.value" clearable placeholder="值" />
              <span
                v-if="index === queryParams.length - 1"
                @click="addParam('queryParams')"
                title="添加项"
                ><i class="el-icon-plus"></i
              ></span>
              <span
                v-if="index > 0"
                @click="deleteParam(queryParams, item.id)"
                title="删除项"
                ><i class="el-icon-minus"></i
              ></span>
            </div>
          </el-form-item>
          <el-form-item label="请求对象body">
            <div
              class="parms-list"
              v-for="(item, index) in bodyParams"
              :key="index"
            >
              <el-input v-model="item.key" clearable placeholder="字段" />
              <el-input v-model="item.value" clearable placeholder="值" />
              <span
                v-if="index === bodyParams.length - 1"
                @click="addParam('bodyParams')"
                title="添加项"
                ><i class="el-icon-plus"></i
              ></span>
              <span
                v-if="index > 0"
                @click="deleteParam(bodyParams, item.id)"
                title="删除项"
                ><i class="el-icon-minus"></i
              ></span>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  computed: {},
  data() {
    return {
      form: {
        title: '',
        ip: 'no',
        mac: 'no',
        method: '',
        path: '',
        desc: '',
        query: {},
        body: {},
        seconds: 0,
        secondsWarningCount: 0,
        secondsLimitCount: 0,
        dayWarningCount: 0,
        dayLimitCount: 0,
        monthWarningCount: 0,
        monthLimitCount: 0,
        usable: true
      },
      queryParams: [
        {
          id: String(Math.random()).substring(2, 12),
          key: '',
          value: ''
        }
      ],
      bodyParams: [
        {
          id: String(Math.random()).substring(2, 12),
          key: '',
          value: ''
        }
      ],
      rules: {
        // name: [
        //   {
        //     required: true,
        //     message:
        //       '输入默认名字，设备的语言在多语言匹配不到，就会显示默认名字',
        //     trigger: 'blur'
        //   }
        // ],
      }
    }
  },
  methods: {
    async getDetails() {
      let res = await this.$http.getDDosConfigDetails(this.$route.query.id)
      this.queryParams = this.filterDetailsParams(res.data.query)
      this.bodyParams = this.filterDetailsParams(res.data.body)
      this.form = Object.assign(this.form, res.data)
    },

    filterDetailsParams(obj) {
      let params = []
      for (let key in obj) {
        let item = {
          id: String(Math.random()).substring(2, 12),
          key: key,
          value: obj[key]
        }
        params.push(item)
      }
      if (params.length === 0) {
        params = [
          {
            id: String(Math.random()).substring(2, 12),
            key: '',
            value: ''
          }
        ]
      }
      return params
    },

    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (this.$route.query.id) {
            this.edit()
          } else {
            this.create()
          }
        } else {
          return false
        }
      })
    },

    async create() {
      this.form.query = this.filterParams(this.queryParams)
      this.form.body = this.filterParams(this.bodyParams)
      await this.$http.addDDosConfig(this.form)
      this.$message({
        type: 'success',
        message: this.$t('alertMsg.addSuccess')
      })
      this.$router.back()
    },

    async edit() {
      this.form.query = this.filterParams(this.queryParams)
      this.form.body = this.filterParams(this.bodyParams)
      await this.$http.updateDDosConfig(this.$route.query.id, this.form)
      this.$message({
        type: 'success',
        message: this.$t('alertMsg.editSuccess')
      })
      this.$router.back()
    },

    filterParams(obj) {
      let params = {}
      obj.map((item) => {
        if (item.key) {
          params[item.key] = item.value
        }
      })
      return Object.assign({}, params)
    },

    addParam(params) {
      let obj = {
        id: String(Math.random()).substring(2, 12),
        key: '',
        value: ''
      }
      this[params].push(obj)
    },

    deleteParam(arr, id) {
      arr.map((item, i) => {
        if (item.id === id) {
          arr.splice(i, 1)
        }
      })
    }
  },
  async mounted() {
    if (!this.$route.query.id) return
    this.getDetails()
  }
}
</script>

<style lang="scss">
.update-mgt-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .body-wrap {
    /* height: 100%; */
    flex: 1;
    overflow: hidden;
    &.params-wrap {
      .parms-list + .parms-list {
        margin-top: 10px;
      }
      .parms-list {
        display: flex;
        > .el-input {
          width: 40%;
          max-width: 300px;
          margin-right: 10px;
        }
        > span {
          width: 30px;
          height: 35px;
          line-height: 32px;
          text-align: center;
          display: inline-block;
          font-size: 20px;
          vertical-align: bottom;
          cursor: pointer;
          color: #555;
        }
      }
    }
    .el-form {
      width: 80%;
      margin: 10px auto;
      .global-button-style {
        width: 100%;
        margin: 0;
      }
      .update-import-btn {
        margin-top: 10px;
      }
      .update-upload-progress {
        display: flex;
        align-items: center;
        > .el-progress__text {
          /* width: 100px; */
        }
      }
    }
  }
}
</style>
